import EstadosLeyenda, { EstadoLeyenda } from "../shared/EstadosLeyenda.tsx";

// Informative only: meaning of each solicitud state, with the same colors
// the table uses (CSS variables in utils/main.css)
const ESTADOS: EstadoLeyenda[] = [
  {
    nombre: "Pendiente",
    color: "var(--color-pendiente)",
    texto: "Solicitud creada.",
  },
  {
    nombre: "Aprobada",
    color: "var(--color-aprobadas)",
    texto:
      "La solicitud ha sido aprobada por la subgerencia responsable del presupuesto.",
  },
  {
    nombre: "Confirmada",
    color: "var(--color-confirmadas)",
    texto:
      "La solicitud ha sido confirmada por el departamento de Adquisiciones.",
  },
  {
    nombre: "Emitida",
    color: "var(--color-emitidas)",
    texto:
      "Se ha creado al menos una orden de compra a partir de esta solicitud.",
  },
  {
    nombre: "Rechazada",
    color: "var(--color-rechazadas)",
    texto: "La solicitud no ha sido aprobada.",
  },
  {
    nombre: "Anulada",
    color: "var(--color-anuladas)",
    texto: "La solicitud ha sido cerrada por errores o duplicidad.",
  },
];

const PARCIALES: EstadoLeyenda[] = [
  { nombre: "Aprobada parcialmente", color: "var(--color-aprobadas-parcial)" },
  {
    nombre: "Rechazada parcialmente",
    color: "var(--color-rechazadas-parcial)",
  },
  {
    nombre: "Confirmada parcialmente",
    color: "var(--color-confirmadas-parcial)",
  },
];

export default function EstadosSolicitudLeyenda() {
  return (
    <EstadosLeyenda
      titulo="Estados de la solicitud"
      estados={ESTADOS}
      parciales={PARCIALES}
      textoParciales="Estados parciales: las líneas de detalle de la solicitud quedaron en estados distintos (por ejemplo, algunas aprobadas y otras pendientes o rechazadas). Revisa el estado de cada línea en el detalle de la solicitud."
    />
  );
}
